export default __webpack_public_path__ + "static/media/radio_button_checked.3637b33a.svg";